module.exports = __webpack_public_path__ + "static/pie4-1e9a4b537e7ffa92cc24d4300f0ecb03.png";